<template lang="html">
  <article class="fc-m-container">
    <h2>Lineups</h2>
    <table class="table table-striped">
      <thead>
        <th scope="col"></th>
        <th scope="col">Date</th>
        <th scope="col">Points</th>
      </thead>
      <!-- No lineups yet message -->
      <tbody v-if="league.status == 'Pending'">
        <tr>
          <td colspan="5">
            No lineups for this team yet.
          </td>
        </tr>
      </tbody>
      <!-- loading -->
      <tbody v-else-if="lineups === null && league.status != 'Pending'">
        <!-- TODO: Need a better way to designate loading than lineups being null -->
        <tr>
          <td colspan="5">
            <loader v-bind:embeded="true"></loader>
          </td>
        </tr>
      </tbody>
      <!-- lineups -->
      <tbody v-else>
        <!-- Placeholder for coming week -->
        <tr
          v-if="showPlaceholder() && this.lineups.hasPrevious === false"
          :class="{
            'fc-a-highlight--blue': activeWeek === null,
            'font-weight-bold': activeWeek === null
          }"
        >
          <td>
            <a
              v-if="activeWeek != null"
              v-on:click.prevent="$emit('update-lineup', null)"
              class="fc-a-link--title fc-a-text--size-4"
              tabindex="0"
              >Wk
              {{
                league.current_week === null ? 1 : league.current_week + 1
              }}</a
            >
            <a class="fc-a-text--size-4" v-else>
              Wk
              {{ league.current_week === null ? 1 : league.current_week + 1 }}
            </a>
          </td>
          <td>
            {{ formatPlaceholderDates() }}
          </td>
          <td>
            <strong>TBD</strong>
          </td>
        </tr>
        <!-- Recorded lineups -->
        <tr
          v-for="lineup in lineups.data"
          :key="lineup.data.week_number"
          :class="{
            'fc-a-highlight--blue': lineup.data.week_number == activeWeek,
            'font-weight-bold': lineup.data.week_number == activeWeek
          }"
        >
          <td>
            <a
              v-if="lineup.data.week_number != activeWeek"
              v-on:click.prevent="
                $emit('update-lineup', lineup.data.week_number)
              "
              class="fc-a-link--title fc-a-text--size-4"
              tabindex="0"
              >Wk {{ lineup.data.week_number }}</a
            >
            <a class="fc-a-text--size-4" v-else>
              Wk {{ lineup.data.week_number }}
            </a>
          </td>
          <td>
            {{ formatDates(lineup.data.week_start) }} /
            {{ formatDates(lineup.data.week_end) }}
          </td>
          <td>
            <strong>{{ lineup.data.points }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- pagination -->
    <div v-if="lineups.hasNext || lineups.hasPrevious">
      <pagination
        v-on:new-page="paginateLineups"
        :next="lineups.hasNext"
        :previous="lineups.hasPrevious"
      ></pagination>
    </div>
  </article>
</template>

<script>
import moment from "moment";
import V2Pagination from "@/views/components/V2Pagination";

export default {
  name: "TeamLineups",
  components: {
    pagination: V2Pagination
  },
  props: {
    lineups: { type: Object },
    league: { type: Object },
    activeWeek: {}
  },
  methods: {
    formatDates: function(date) {
      let pieces = date.split("-");
      return pieces.length >= 3 ? `${pieces[1]}-${pieces[2]}` : "";
    },
    formatPlaceholderDates: function() {
      const placeholderWeek =
        this.league.current_week === null ? 1 : this.league.current_week + 1;

      const weekStart = moment(this.league.draft_date, "YYYY-MM-DD")
        .utc()
        .startOf("week")
        .add(placeholderWeek, "weeks");

      const weekEnd = moment(this.league.draft_date, "YYYY-MM-DD")
        .utc()
        .endOf("week")
        .add(placeholderWeek, "weeks");

      return `${weekStart.format("MM-DD")} / ${weekEnd.format("MM-DD")}`;
    },
    paginateLineups: function(direction) {
      this.$emit("paginate-lineups", direction);
    },
    showPlaceholder: function() {
      return (
        this.league.status != "Complete" &&
        this.league.current_week != this.league.season_length
      );
    }
  }
};
</script>
